export const Sort = Object.freeze({
  Name: 1,
  Price: 2,
  Date: 3,
  New: 4,
  Score: 5
});
